<template>
	<button
		:disabled="isOrigin || (isPrivate && !canCreatePrivateCollection)"
		class="popover-link overflow-hidden h-20 justify-between gap-8"
		:class="[
			collection.archived ? 'text-gray-400' : isSelected ? 'bg-gray-500 text-gray-100' : 'text-gray-300',
			{'hover:bg-transparent': isOrigin},
			{'text-gray-100 cursor-not-allowed': isPrivate && !canCreatePrivateCollection},
		]"
		@click="$emit('select')"
	>
		<div class="flex items-center gap-8 overflow-x-hidden flex-grow">
			<BaseIcon v-if="isPrivate" name="mono/lock" />
			<BaseIcon v-else name="mono/collection" />

			<p class="truncate flex-grow" :title="collection.name">{{ collection.name }}</p>
			<div class="flex items-center flex-none gap-8">
				<BaseIcon v-if="collection.workspaceCollectionSettingsLinear" name="linear" class="w-12 h-12" />
				<BaseIcon v-else-if="collection.workspaceCollectionSettingsJira" name="jira" class="w-12 h-12" />
				<BaseIcon v-else-if="collection.workspaceCollectionSettingsSlack" name="slack" class="w-12 h-12" />
				<BaseIcon v-else-if="collection.workspaceCollectionSettingsGithub" name="github" class="w-12 h-12" />
			</div>
		</div>
		<div class="flex flex-none items-center gap-4">
			<span
				v-if="collection.archived"
				class="flex-none py-1 px-4 rounded border border-gray-500 text-gray-400 text-sm"
			>
				Archived
			</span>

			<BaseIcon v-if="isSelected" ref="selectedCollection" name="mono/check" />

			<span
				v-if="isOrigin"
				ref="originCollection"
				class="flex-none py-1 px-4 rounded bg-gray-500 text-gray-300 text-sm border border-gray-500"
			>
				Current
			</span>
		</div>
	</button>
</template>

<script>
import {FEATURE_CODES} from 'shared/constants/featureCodes'

export default {
	name: 'CollectionSelectItem',
	props: {
		collection: {type: Object, required: true},
		selectedCollection: {type: Object, required: true},
	},
	emits: ['select'],
	computed: {
		isSelected() {
			return this.collection?.id === this.selectedCollection.id
		},
		isOrigin() {
			return this.collection?.id === this.$store.collection.id
		},
		isPrivate() {
			return this.collection.accessPermission === 'closed'
		},
		canCreatePrivateCollection() {
			return this.$store.hasPlanFeature(FEATURE_CODES.PRIVATE_FOLDERS)
		},
	},
}
</script>
